export default __webpack_public_path__ + "de822394a4427f143afc8d31eebf98d4.svg";